import {
  getUserInfoApi,
  getVipInfoApi,
  taskScheduleApi,
  getSigninPointApi,
} from "./api/user.js";

const getUserInfo = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await getUserInfoApi();
      const data = res.data;
      if (data.code >= 300) {
        reject({
          code: data.code,
          msg: data.msg,
        });
      }
      resolve(data.data);
    } catch (error) {
      reject({
        msg: error.msg || "获取用户信息失败",
      });
    }
  });
};

const getVipInfo = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await getVipInfoApi();
      const data = res.data;
      if (data.code >= 300) {
        reject({
          code: data.code,
          msg: data.msg,
        });
      }
      resolve(data.data);
    } catch (error) {
      reject({
        msg: error.msg || "获取vip信息失败",
      });
    }
  });
};

const getTaskSchedule = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await taskScheduleApi();
      const data = res.data;
      if (data.code >= 300) {
        reject({
          code: data.code,
          msg: data.msg,
        });
      }
      resolve(data.data);
    } catch (error) {
      reject({
        msg: error.msg || "获取任务数据失败",
      });
    }
  });
};

const getSigninPoint = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await getSigninPointApi();
      const data = res.data;
      if (data.code >= 300) {
        reject({
          code: data.code,
          msg: data.msg,
        });
      }
      resolve();
    } catch (error) {
      reject({
        msg: error.msg || "获取签到积分失败",
      });
    }
  });
};
export { getUserInfo, getVipInfo, getTaskSchedule, getSigninPoint };
